import { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
// Constants - Functions
import { WEB_SERVICE_MIMS } from "../../../../config/constants";
// Components
import {
  MainDiv,
  NotesTitle,
  NoNotesDiv,
  NoNotesText,
  NotesDiv,
  NoteDate,
  NoteBox,
  OpenPopupButton,
  OpenPopupImg,
  ActionsDiv,
  NewNoteButton,
} from "./styles";
import UseFetch from "../../../../config/useFetch";
import Loader from "../../../loader";
import Title from "../../../title";
import Popup from "../../../popup";
import NewNotePopup from "./sections/addNote";
import EditNotePopup from "./sections/editNote";
// Assets
import EditIcon from "../../../../assets/icons/btn_edit_user_blue.svg";

const Notes = () => {
  const [notes, setNotes] = useState([]);
  const [isLoadingNotes, setIsNotes] = useState(true);
  const [refreshData, setRefreshData] = useState(false);
  // New note
  const [showNewNote, setShowNewNote] = useState(false);
  // Edit note
  const [showEditNote, setShowEditNote] = useState(false);
  const [editNoteData, setEditNoteData] = useState({});

  const { patientId } = useParams();

  // Fetch notes
  useEffect(() => {
    setIsNotes(true);

    UseFetch("get", `${WEB_SERVICE_MIMS}/recsys/get-notes/${patientId}`)
      .then(({ data }) => {
        setNotes(data);
        setIsNotes(false);
      })
      .catch((error) => {
        console.log("Get notes: ", error);
      });

    return () => {
      setNotes([]);
      setIsNotes(true);
    };
  }, [patientId, refreshData]);

  const renderEditNotePopup = () => {
    return (
      <Popup isShowed={showEditNote} setIsShowed={setShowEditNote}>
        <EditNotePopup
          setShowEditNote={setShowEditNote}
          editNoteData={editNoteData}
          refreshData={refreshData}
          setRefreshData={setRefreshData}
        />
      </Popup>
    );
  };

  const renderNotes = () => {
    return notes.map((note) => {
      const handleSetNoteData = () => {
        setEditNoteData(note);
        setShowEditNote(true);
      };

      return (
        <NotesDiv key={note.RECSYS_NOTES_ID}>
          <NoteDate>{note.NOTE_CREATION_DATE}</NoteDate>
          <NoteBox>{note.NOTE}</NoteBox>
          <OpenPopupButton onClick={handleSetNoteData}>
            <OpenPopupImg src={EditIcon} alt="edit-ico" />
          </OpenPopupButton>
        </NotesDiv>
      );
    });
  };

  const renderNewNotePopup = () => {
    return (
      <Popup isShowed={showNewNote} setIsShowed={setShowNewNote}>
        <NewNotePopup setShowNewNote={setShowNewNote} refreshData={refreshData} setRefreshData={setRefreshData} />
      </Popup>
    );
  };

  return (
    <>
      <Title title={"NOTES"} marginBottom="15px" />
      {isLoadingNotes ? (
        <Loader height={50} />
      ) : (
        <>
          <MainDiv>
            <NotesTitle>Notes</NotesTitle>
            {Boolean(!notes.length) ? (
              <NoNotesDiv>
                <NoNotesText>There are no notes</NoNotesText>
              </NoNotesDiv>
            ) : (
              <>{renderNotes()}</>
            )}
            <ActionsDiv>
              <NewNoteButton onClick={() => setShowNewNote(true)}>New note</NewNoteButton>
            </ActionsDiv>
            {showNewNote && renderNewNotePopup()}
            {showEditNote && renderEditNotePopup()}
          </MainDiv>
        </>
      )}
    </>
  );
};

export default Notes;
